import React from "react";
import { Link } from "react-router-dom";
import AuthenticatedTemplate from "../components/AuthenticatedTemplate";
import { Footer } from "../components/Footer";
import { LOGOS, IMAGES } from "../utils/assets";
import Button from "../components/form/Button";

export const PaymentFailed = () => {
  return (
    <>
      <AuthenticatedTemplate>
        <section className="step__container">
          <div className="step__content">
            <div className="payment-failed">
              <div className="step__header">
                <img
                  className="logo"
                  src={LOGOS.QUICKMOVE_FLOW}
                  alt="Quickmove Logo"
                />
                <div>
                  <h1 className="text-md text-md--variant">
                    Oh no! Your payment failed!
                  </h1>
                  <p className="paragraph-md">
                    Don't worry! We have saved your details. You can try to make
                    the payment again.
                  </p>
                </div>
              </div>

              <img
                src={IMAGES.EXCLAMATION_IMAGE}
                className="payment-failed__image"
                alt="Illustration of an exclamation mark"
              />

              <div className="action-buttons">
                <Link to="/dashboard-review-details">
                  <Button variant="outlined">Back</Button>
                </Link>
                <Link to="/dashboard-checkout">
                  <Button variant="primary">Try again</Button>
                </Link>
              </div>
              <Footer />
            </div>
          </div>
        </section>
      </AuthenticatedTemplate>
    </>
  );
};
